import { Link } from "@tanstack/react-router";
import { motion } from "framer-motion";

import { Button } from "../components/ui/Button";
import { fadeInUp, scaleIn } from "../lib/animations";

export function NotFoundPage() {
	return (
		<div className="flex min-h-[60vh] flex-col items-center justify-center text-center px-4">
			<motion.h1
				variants={scaleIn}
				initial="hidden"
				animate="visible"
				className="text-8xl font-extrabold text-gradient"
			>
				404
			</motion.h1>
			<motion.div variants={fadeInUp} initial="hidden" animate="visible">
				<p className="mt-4 text-xl text-pastel-gray">This page doesn't exist</p>
				<div className="mt-8">
					<Link to="/">
						<Button variant="gradient" size="lg">
							Go Home
						</Button>
					</Link>
				</div>
			</motion.div>
		</div>
	);
}
